import React, { useState } from 'react';
import AutoI from './Auto';
import ResidentialI from './Residential';
import CommercialI from './CommercialI';
const EnquiryTabs = () => {
    const [activeTab, setActiveTab] = useState('auto');

    return (
        <div className="h-auto relative ">
        <div className=" md:w-auto sm:w-full absolute md:top-64 sm:top-0 md:left-48 lg:left-48 flex gap-4 p-4 bg-secondary md:-skew-x-6 rounded-lg shadow-lg z-10">
            <button
                className={`px-6 py-2 rounded-lg font-nunito-sans text-lg ${
                    activeTab === 'auto'
                        ? 'bg-primary text-accent'
                        : 'bg-accent text-primary hover:bg-primary hover:text-accent transition'
                }`}
                onClick={() => setActiveTab('auto')}
            >
                Auto
            </button>
            <button
                className={`px-6 py-2 rounded-lg font-nunito-sans text-lg ${
                    activeTab === 'residential'
                        ? 'bg-primary text-accent'
                        : 'bg-accent text-primary hover:bg-primary hover:text-accent transition'
                }`}
                onClick={() => setActiveTab('residential')}
            >
                Residential
            </button>
            <button
                className={`px-6 py-2 rounded-lg font-nunito-sans text-lg ${
                    activeTab === 'commercial'
                        ? 'bg-primary text-accent'
                        : 'bg-accent text-primary hover:bg-primary hover:text-accent transition'
                }`}
                onClick={() => setActiveTab('commercial')}
            >
                Commercial
            </button>
        </div>
        <div className="pt-16"> {/* Add some padding top to avoid overlap */}
            {activeTab === 'auto' && <AutoI />}
            {activeTab === 'residential' && <ResidentialI />}
            {activeTab === 'commercial' && <CommercialI />}
        </div>
    </div>
    
    );
};

export default EnquiryTabs;
